var map = {
	"./en/iphone.png": 2297,
	"./en/iphone@2x.png": 2298,
	"./es/iphone.png": 2299,
	"./es/iphone@2x.png": 2300,
	"./ru/iphone.png": 2301,
	"./ru/iphone@2x.png": 2302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2296;